import { useEffect, useState, useCallback } from 'react';

const useInfiniteScroll = (
  shouldFetch: boolean,
  fetchMoreCallback: () => Promise<any>
): [boolean] => {
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = useCallback(() => {
    const container = document.documentElement;
    const footerHeight = document.getElementById('footer')?.offsetHeight || 0;
    const scrolledHeight = container?.scrollTop || window.scrollY;
    const visibleHeight = container?.clientHeight || window.innerHeight;
    const totalHeight = container?.scrollHeight || document.documentElement.scrollHeight;

    if (totalHeight - footerHeight - (visibleHeight + scrolledHeight) > 0) return;

    setIsFetching(true);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return (): void => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (!isFetching || !shouldFetch) return;

    fetchMoreCallback().then(() => setIsFetching(false));
  }, [isFetching, shouldFetch, fetchMoreCallback]);

  return [isFetching];
};

export default useInfiniteScroll;
